import { useAuth } from "@/features/auth/hooks/useAuth";
import { useEffect } from "react";
import { useAnalytics } from "@/features/analytics/context/AnalyticsProvider";
import type { CitationRoute } from "@/features/analytics/types/events";

export const useTrackCitationView = (
  citationRoute: CitationRoute,
  docId: string | undefined,
  data: { meta: { source?: string } } | null,
  highlightLineCount: number,
) => {
  const { trackEvent } = useAnalytics();
  const { user, loading: authLoading } = useAuth();

  useEffect(() => {
    if (!data || !docId || authLoading) return;

    trackEvent("view_citation", {
      citation_route: citationRoute,
      doc_id: docId,
      ...(highlightLineCount > 0 && { highlight_line_count: highlightLineCount }),
      ...(data.meta.source && { meta_source: data.meta.source }),
      ...(user?.id && { gxl_user_id: user.id }),
    });
  }, [citationRoute, data, docId, highlightLineCount, authLoading, user?.id, trackEvent]);
};
